import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Serverurl from './Apiurl';
import FormControl from '@mui/material/FormControl';
import OTPInput from 'react-otp-input';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Athalogo from './images/logo-bg.png';
import Input from '@mui/material/Input';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';

import { auth,firebase  } from "../firebaseotp";
export default class Regsitration extends Component {
	constructor(props) {
    super(props);
	 this.state = {otp:'',otp1:'',otp2:'',otp3:'',otp4:'',otp5:'',otp6:'',	 alerttype:'error',registermsg:false,otEmail:'',hasFilled:false,
	 erroropen:false,pnlfrm:false,showPassword:false,conshowPassword:false, Name:'',pagename:'',btnverdisabled:false,btnverifytext:'Submit',
	 redirect:false,Email:'',Phoneno:'',Password:'',isverifid:false,btndisabled:false,btntext:'Register',otpscren:0}
	 
	}
	
	handleClickShowPassword = () => {
    
	this.setState({
            showPassword: !this.state.showPassword
          })
  };
	handleClickconPassword = () => {
    
	this.setState({
            conshowPassword: !this.state.conshowPassword
          })
  };
  componentDidMount() {
	let search = window.location.href;
		
	let UserId = this.getParameterByName('Uname',search);
	if(UserId!==null )
	{
		localStorage.setItem("AYphoneotp",UserId)
	this.setState({otEmail: '',registermsg:false,otpscren:1, pnlfrm:true},()=>{this.onloadgetOTP();});
	
	}
if(localStorage.getItem("AYphoneotp")!==null )
	{
		
	this.setState({otEmail:localStorage.getItem("AYphoneotp"),registermsg:false,otpscren:1, pnlfrm:true},()=>{this.onloadgetOTP();});
	
	}	
}

onloadgetOTP()
{
	let Email=this.state.otEmail;
	var formData = new FormData();
	 /* formData.append('action','sessionup')
formData.append('cu_emailid',Email)	  
	  
		axios.post(Serverurl+"ajaxcustomer.php", formData, {
		    }).then(res => {
				this.setState({registermsg:true, pnlfrm:true});
			});*/
}

getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
generateRecaptcha= () => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha', {
      'size': 'invisible',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // ...
      }
    }, auth);
  }
generateRecaptcha1= () => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha1', {
      'size': 'invisible',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // ...
      }
    }, auth);
  }
  generateRecaptcha2= () => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha2', {
      'size': 'invisible',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // ...
      }
    }, auth);
  }
  onValidateemail= event => {
	let Email = this.state.Email;
	
	var formData = new FormData();
 
    formData.append('action','checkemail')
		formData.append('cu_emailid',Email)
		
		 axios.post(Serverurl+"ajaxcustomer.php", formData, {
        }).then(res => {
			
			if(res.data!==0)
			{
				this.setState({errormessage:"Email Id already Exist, Please login",erroropen:true,isverifid:true});
	 window.scrollTo({        top: 0     })
	return false;
			}else
			{
				this.setState({errormessage:"",erroropen:false,isverifid:false});
			}
		})
}
OnclickRegister=(event)=>{
    event.preventDefault();
let name = this.state.Name;
let Email = this.state.Email;
let Phoneno = this.state.Phoneno;
let Password = this.state.Password;
let confPassword = this.state.confPassword;

let testVerificationCode='981234';
//firebase.auth().settings.appVerificationDisabledForTesting = true;

		 

 
     
const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
   if(name==="")
{
	this.setState({errormessage:"Please Enter Name.",erroropen:true});
	 window.scrollTo({        top: 0     })
	return false;
}

   if(Email==="")
{
	this.setState({errormessage:"Please Enter Email.",erroropen:true});
	 window.scrollTo({        top: 0     })
	return false;
} else  
  {
 if (!remail.test(Email)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erroropen:true});
		 window.scrollTo({        top: 0     })
	return false; 
  }
	  
  }
   if(Phoneno==="")
{
	this.setState({errormessage:"Please Enter Mobile No.",erroropen:true});
	 window.scrollTo({        top: 0     })
	return false;
}else{
	if(Phoneno.length<10)
	{
		this.setState({errormessage:"Please Enter Valid 10 Digit Mobile No.",erroropen:true});
		 window.scrollTo({        top: 0     })
	return false;
	}
}
  if(Password==="")
{
	this.setState({errormessage:"Please Enter Password",erroropen:true});
	 window.scrollTo({        top: 0     })
	return false;
}else{
	if(Password.length<6)
	{
		this.setState({errormessage:"Please Enter Strong Password.",erroropen:true});
		 window.scrollTo({        top: 0     })
	return false;
	}
}

 if(confPassword!==Password)
{
	this.setState({errormessage:"Please ReType Correct Password",erroropen:true});
	return false;
}



  this.setState({btndisabled:true,btntext:'Processing...',errormessage:'',erroropen:false});



 this.generateRecaptcha();
 let appVerifier = window.recaptchaVerifier;
var formData = new FormData();
 
    formData.append('action','Register')
		formData.append('cu_name',name)
	formData.append('cu_phoneno',Phoneno)
	formData.append('cu_password',Password)
		formData.append('cu_emailid',Email)
		
		
		signInWithPhoneNumber(auth,'+91'+Phoneno,appVerifier)
            .then((confirmationResult) => {
               // setfinal(result);
			   
                console.log(confirmationResult);
			     window.confirmationResult= confirmationResult;
	
               axios.post(Serverurl+"ajaxcustomer.php", formData, {
        }).then(res => {
			
				var strreturn=res.data.split('~');
	
			if(strreturn[1].trim()==="1")
			{
				localStorage.setItem("AYOTP",strreturn[0])
				localStorage.setItem("AYphoneotp",Phoneno)
		 	this.setState({btndisabled:false,btntext:'Regsiter', registermsg:true, pnlfrm:true });
			}else{
				
				this.setState({btndisabled:false,btntext:'Regsiter', registermsg:false, pnlfrm:true, errormessage:"Account already exist, please Signin",erroropen:true,isverifid:true});
				localStorage.setItem("AYphoneotp",Phoneno)
				localStorage.setItem("AYOTP",strreturn[0])
			}
		});
            })
            .catch((err) => {
				 this.setState({btndisabled:false,btntext:'Sign Up',errormessage:err,erroropen:true});

                window.location.reload();
            });
		
	 
}	
OnclickVerify=(event)=>{
    event.preventDefault();
	let phone = localStorage.getItem("AYphoneotp");
	 let otp=this.state.otp;
	 var self=this;
		   
 var formData = new FormData();
 
    formData.append('action','verify')
	 		formData.append('cu_emailid',phone) 
			formData.append('cu_sessionid',localStorage.getItem("AYOTP")) 
if (otp === '' ) {
		
		this.setState({errormessage:"Please Enter OTP",erroropen:true});
			 window.scrollTo({        top: 0     })
		return false;
	 }
	  let confirmationResult1 = window.confirmationResult;
      confirmationResult1.confirm(otp).then((result) => {
        // User signed in successfully.
        let user = result.user;
       self.setState({errormessage:"",erroropen:false,btnverdisabled:true,btnverifytext:'Processing...'});
	
			axios.post(Serverurl+"ajaxcustomer.php", formData, {
			}).then(res => {
			
		 localStorage.removeItem("AYphoneotp")
				 self.setState({btnverdisabled:false,btnverifytext:'Submit',registermsg:false,isverifid:true,
					 errormessage:"Your account has been verified, please  sign in",erroropen:true,alerttype:'success'
					 });
			});
			
      }).catch((error) => {
	   this.setState({btnverdisabled:false,btnverifytext:'Verify',errormessage:"Please Enter Valid OTP",erroropen:true});
			 window.scrollTo({        top: 0     })
		return false;
      });
	 
	
	  
	  
}

handleResend=(event)=>{
	
	this.setState({otpscren:1,registermsg:false})
	
}
handleverifyphone=(event)=>{
	let phone=this.state.otEmail;
	if( phone==="")
	{
			this.setState({errormessage:"Please Enter Valid 10 Digit Mobile No.",erroropen:true});
		 window.scrollTo({        top: 0     })	
		 return false;
	}
	 this.generateRecaptcha1();
 let appVerifier = window.recaptchaVerifier;
	var formData = new FormData();
	  formData.append('action','sessionup')
formData.append('cu_emailid',localStorage.getItem("AYphoneotp"))	  
	formData.append('cu_phoneno',phone)  
	  		
		 signInWithPhoneNumber(auth,"+91"+phone,appVerifier)
            .then((confirmationResult) => {
            
			   
                
			     window.confirmationResult= confirmationResult;
	
					axios.post(Serverurl+"ajaxcustomer.php", formData, {
					}).then(res => {
						var str=res.data;
						localStorage.setItem("AYOTP",str)
						localStorage.setItem("AYphoneotp",phone)
						this.setState({registermsg:true,otpscren:0, pnlfrm:true,errormessage:"OTP Sent",erroropen:true,alerttype:'success',isverifid:false});
					});
            })
            .catch((err) => {
                alert(err);
                window.location.href=window.location.href;
            });	
		
}
handleresendSubmit= (event) => {
	
	let phone=localStorage.getItem("AYphoneotp");
	//window.location.reload();
	/*var formData = new FormData();
	  formData.append('action','resend')
formData.append('cu_emailid',localStorage.getItem("AYphoneotp"))	  
	  
		axios.post(Serverurl+"ajaxcustomer.php", formData, {
		    }).then(res => {
				let strreturn=res.data;
				
				if(strreturn!==0)
				{
					
			this.setState({errormessage:"OTP has been sent to your email Id.",erroropen:true,alerttype:'success'});	

		this.setState({otpscren:0,registermsg:true})
				}else
				{
	this.setState({errormessage:"Please Enter valid Email id",erroropen:true});
 	
					
				}
			});*/
			
			this.setState({btnverdisabled:false,btnverifytext:'Verify',});
			
if(phone===null || phone==="")
	{
			this.setState({errormessage:"Please Enter Valid 10 Digit Mobile No.",erroropen:true});
		 window.scrollTo({        top: 0     })	
		 return false;
	}
	 this.generateRecaptcha2();
 let appVerifier = window.recaptchaVerifier;		
		 signInWithPhoneNumber(auth,'+91'+phone,appVerifier)
            .then((confirmationResult) => {
               // setfinal(result);
			   
                console.log(confirmationResult);
			     window.confirmationResult= confirmationResult;
	
               // setshow(true);
            })
            .catch((err) => {
                alert(err);
                window.location.reload();
            });	
}

handleErrorclose=(event)=>{
	  
	this.setState({erroropen: false});  
  }
  setOtp(val)
  {
	this.setState({otp: val});    
  }
handleotpChange =(OTP) => {
	 const repho = /^[0-9\b]+$/;
	 let strotp="";
	 if(repho.test(OTP)){
		strotp= OTP;
	 }
	if(strotp!==" "){
	
	this.setOtp(strotp);
	}
	//this.setState({otp: OTP});
}


handleChange = event => {
	
let nam = event.target.name;
  let val = event.target.value;
  var self=this;
  const repho = /^[0-9\b]+$/;
  this.setState({[nam]: val});
  if(nam==="Phoneno")
  {
	  if (event.target.value === '' || repho.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
   else if(nam==="otEmail")
  {
	  if (event.target.value === '' || repho.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
  
 
  else{
	  
	   this.setState({[nam]: val});
  }
 };

	  handleMouseDownPassword = event => {
    event.preventDefault();
  };
	 render(){
		 let index=0;let index1=0;
	 	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	
	
	 
	 return(
	 <div className="signin-bg">
	  <div className="signinlogo">
	  <img src={Athalogo} alt="Atha Yoga" />
	  </div>
	 <div className="regformbg">

	 <div className="regform">	 <h2>Let's Get Started</h2>
	  <p>  <Collapse in={this.state.erroropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  {this.state.isverifid===true &&(
	    <p className="signuplink linkcolor">
	Click here to <a href='close.html' className="secondlinks">Login In</a>
	 </p>
	  )}
	  {this.state.pnlfrm===false &&( <React.Fragment>  
	  <div id="recaptcha"></div>
	 <p>
	 <TextField id="Name" name="Name" className="signinptmob"  variant="outlined"  placeholder="Your Name"
            fullWidth inputProps={{maxLength:150,  }} autoFocus
			value={this.state.Name}  onChange={this.handleChange}/> 
	 
	 </p> 
	 <p>
	 	 <TextField id="Email" name="Email" className="signinptmob" variant="outlined"  placeholder="Your Email"
            fullWidth inputProps={{maxLength:150,  }} 
			value={this.state.Email} onBlur={this.onValidateemail}  onChange={this.handleChange}/>
	 </p>
	  <p>
	 	 <TextField id="Phoneno" name="Phoneno"  className="signinptmob" variant="outlined"  placeholder="Mobile"
            fullWidth inputProps={{maxLength:10,  }} 
			value={this.state.Phoneno}  onChange={this.handleChange}/>
	 </p>
	   <p>
	 	 <FormControl fullWidth variant="outlined" className="signinptmob" 	inputlabelprops={{ shrink: false }}>
         
          <Input 
             id="Password" name="Password"   value={this.state.Password} placeholder="Password"
            type={this.state.showPassword ? 'text' : 'password'}  onChange={this.handleChange}
		
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                  edge="end"
				   style={{ color: this.state.conshowPassword ? "#42750b" : "#42750b" }}
                >
                  {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
	 </p>
	 <p>
	 	 <FormControl  fullWidth variant="outlined" className="signinptmob">
         
          <Input
             id="confPassword" name="confPassword"   value={this.state.confPassword} placeholder="Confirm Password"
            type={this.state.conshowPassword ? 'text' : 'password'}  onChange={this.handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickconPassword}
                  onMouseDown={this.handleMouseDownPassword}
                  edge="end"
				   style={{ color: this.state.conshowPassword ? "#42750b" : "#42750b" }}
                >
                  {this.state.conshowPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
	 </p>
	 
	 <p><Button
            type="submit"
            fullWidth        className="primarybtncolr"
			disabled={this.state.btndisabled}
            variant="contained" 
           
           id="searchform" 
		onClick={this.OnclickRegister}
           
          >
           {this.state.btntext} 
          </Button>
		  </p>
		  <p className="signuplink linkcolor sublinetext">Have an account? <a href='close.html' className="secondlinks"> Sign In</a></p>
	  </React.Fragment>   )}
	   {this.state.registermsg===true &&(
	  <div id="pnlmsg" >
	  <div className="messagetxt">
 <p> An OTP has been sent to your phone account.</p>
<p>Please check your phone and enter the OTP activate your account.</p> 

</div> 
<OTPInput
            onChange={this.handleotpChange}
            value={this.state.otp} 
            inputStyle="inputStyle"
            numInputs={6} 
            separator={<span></span>}
			 renderInput={(props) => <input {...props} />}
          /> <div id="recaptcha1"></div>
	 <p className="signbutnleft">

<Button
            type="submit" fullWidth
            className="secondbtncolr"
            variant="contained" 
            color="primary"
            onClick={this.handleresendSubmit}
          >
          Resend 
          </Button>

		  </p>
  <div id="recaptcha2"></div>
<p className="signbutnright">
<Button
            type="submit"
            fullWidth  placeholder="*"
			disabled={this.state.btnverdisabled}
            variant="contained" 
             className="primarybtncolr"
           id="searchform" 
		onClick={this.OnclickVerify}
           
          >
           {this.state.btnverifytext} 
          </Button>
</p>
<div className="clear"></div>
		  </div>
	  )}
	  
	   {this.state.otpscren ===1 && (
	    <React.Fragment>
	<div className="btncenter">   <p>
	    <TextField
            variant="outlined"
            margin="normal"
            required value={this.state.otEmail}
            fullWidth className="signinptmob"
            id="email" 
            placeholder="Phone No."
            name="otEmail" onChange={this.handleChange}
            inputProps={{maxLength:10,  }}
            autoFocus
          />
	   </p>
	    <div id="recaptcha1"></div>
	   <p className="primarybtnnew">
<Button
            type="submit"
             className="primarybtncolr"
            variant="contained" 
          fullWidth
            onClick={this.handleverifyphone}
          >
          Submit
          </Button>
</p></div>
	   </React.Fragment>   )}
	 
	 </div>
	
	  </div>
	  <div className="formfooter">
	  <ul>
	  
	  <li><a href="https://athayogliving.com/athayog-app/terms" target="_blank">
	  Terms and Conditions</a>
	  </li>|
	
	   <li><a href="https://athayogliving.com/athayog-app/privacy" target="_blank">
	  Privacy Policy</a>
	  </li>|
	  <li><a href="https://athayogliving.com/athayog-app/refund" target="_blank">
	  Refund Policy</a>
	  </li>  </ul>
	 </div>
	 </div>
	 )
	
	 }
}





